import axios from 'axios';
import transformAvailability from './transformAvailability';
import { Availability } from '../interfaces/Availability';
import { AvailabilityDto } from '../interfaces/dtos/AvailabilityDto';
import { getAvailabilityUrl } from './getAvailabilityUrl';

export async function validateAvailability(group: string, company: null | '0' | '6' = null, experience: null | 'CLIENT' | 'ADVISOR' | 'EMPLOYEE' = null, publicRoute = false): Promise<Availability> {
  const response = await axios.get<AvailabilityDto>(getAvailabilityUrl(group, company, experience, publicRoute));
  return transformAvailability(response.data);
}
